<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/account/statement">
                    <icon name="file-invoice"></icon>
                    รายการเดบิต - เครดิต
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "statement-layout"
    }
</script>

<style scoped>

</style>
